import { css } from '@emotion/css';

export const maxW264 = css`
  max-width: 26.4rem;
`;

export const maxW200 = css`
  max-width: 20rem;
`;

export const maxW300 = css`
  max-width: 30rem;
`;

export const maxW364 = css`
  max-width: 36.4rem;
`;
